import { graphql } from '@api/generated';

export const getUsersAvailabilityActivityQuery = graphql(`
  query getUsersAvailabilityActivityQuery($skipStats: Boolean = true) {
    users {
      items {
        ...ServiceUserFields
        ...ServiceUserStats @skip(if: $skipStats)
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);
